import { createAction, props } from '@ngrx/store';

export const buyAgainSuccess = createAction(
  '[Buy Again Component] Buy Again Success',
  props<{ cartId: string }>()
);
